var include_top_emergency = `
<ul id="emergencyArea" class="contents-wrap top-emergency">
    <li class="top-emergency--item top-emergency--red">
        <a href="" class="top-emergency--link"><span class="top-emergency__lead-blank">お知らせタイトルあいうえおあいうえおあいうえお</span></a>
    </li>
    <li class="top-emergency--item">
        <a href="" class="top-emergency--link"><span class="top-emergency__lead-pdf">お知らせタイトルあいうえおあいうえおあいうえお</span></span></a>
    </li>
    <li class="top-emergency--item top-emergency--red accordion">
        <div class="top-emergency--accordion js-emergency_accordion is-close">
            <div class="accordion-ttl">お知らせタイトルあいうえおあいうえおあいうえお</div>
            <div class="accordion-txt js-hide__target" style="display: none;">お知らせ本文あいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえお</div>
        </div>
    </li>
    <li class="top-emergency--item accordion">
        <div class="top-emergency--accordion js-emergency_accordion is-close">
            <div class="accordion-ttl">お知らせタイトルあいうえおあいうえおあいうえお</div>
            <div class="accordion-txt js-hide__target" style="display: none;">
                <ul class="accordion-lst">
                    <li class="accordion-item">お知らせ本文あいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえおあいうえお</li>
                    <li class="accordion-item">お知らせ本文aaaaaaaa</li>
                </ul>
            </div>
        </div>
    </li>
</ul>
`;
